import { axiosPost } from "../../Helpers";

export const loadCompaniesSearch = async (data, setLoading) => {
  let apiResponse = await axiosPost("user/searchCompanies", data);
  console.log("apiResponse.data.data: ", apiResponse);
  setLoading(false);
  return apiResponse.data.data;
};
